/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */
import {AfterViewInit, Directive, HostBinding} from '@angular/core';

import {AuthenticationService} from './authentication.service';

/**
 * Directive that help display or not a component according to the user authentication status.
 *
 * Usage:
 *
 * ```
 * <div gp-authenticated>Visible only if you're logged in</div>
 * <div gp-authenticated="false">Visible only if you're logged out</div>
 *
 * ```
 */
@Directive({
  selector: '[gp-authenticated-class]'
})
export class AuthenticatedClassDirective implements AfterViewInit {

  @HostBinding('class.authenticated') get className() {
    return this.authenticated;
  }

  public authenticated: boolean = false;

  public ngAfterViewInit() {
    setTimeout(() => {
      // Wrap initialization call in a setTimeout, so that in "mock mode" we are sure the mocks are initialized
      // before triggering any HTTP call in AuthenticationService#isAuthenticated
      this.check();
      this.authenticationService.authenticationEvents.subscribe(this.check.bind(this));
    });
  }

  public check() {
    this.authenticationService.isAuthenticated().then(authenticated => {
      this.authenticated = authenticated;
    });
  }

  constructor(private authenticationService: AuthenticationService) {
  }
}
